module.exports = __webpack_public_path__ + "static/media/curso.4fc18680.png";